/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hood_Db_BodyInputs */

const en_hood_db_body = /** @type {(inputs: Hood_Db_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One Postgres. Row-level security keeps every brand and organisation to its own rows.`)
};

/**
* | output |
* | --- |
* | "One Postgres. Row-level security keeps every brand and organisation to its own rows." |
*
* @param {Hood_Db_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hood_db_body = /** @type {((inputs?: Hood_Db_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hood_Db_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hood_db_body(inputs)
});